function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 18,
  cy: 18,
  r: 18
}), /*#__PURE__*/React.createElement("filter", {
  x: "-18.1%",
  y: "-15.3%",
  width: "136.1%",
  height: "136.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.294117647   0 0 0 0 0.250980392   0 0 0 0 0.22745098  0 0 0 0.3 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu/icon-Practice-Resources",
  transform: "translate(4.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "survey-white"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#F3EFEA",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})))), /*#__PURE__*/React.createElement("g", {
  id: "icon/resources",
  transform: "translate(8.000000, 8.000000)",
  fill: "#61B3CD"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.2278333,1.17066667 C17.2136667,1.17066667 18.8286667,2.7865 18.8286667,4.7715 C18.8286667,6.75733333 17.2136667,8.37316667 15.2278333,8.37316667 C13.242,8.37316667 11.6278333,6.75733333 11.6278333,4.7715 C11.6278333,2.78566667 13.2428333,1.17066667 15.2278333,1.17066667 M15.2278333,9.54316667 C17.8595,9.54316667 20.0003333,7.40316667 20.0003333,4.7715 C20.0003333,2.14066667 17.8595,-0.000166666667 15.2278333,-0.000166666667 C12.597,-0.000166666667 10.4561667,2.14066667 10.4561667,4.7715 C10.4561667,7.40316667 12.597,9.54316667 15.2278333,9.54316667",
  id: "Fill-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.17,20 L20.0008333,20 L20.0008333,11.1691667 L11.17,11.1691667 L11.17,20 Z M12.3408333,18.8291667 L18.8291667,18.8291667 L18.8291667,12.34 L12.3408333,12.34 L12.3408333,18.8291667 Z",
  id: "Fill-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.01133333,7.865 L5.13133333,2.37083333 L8.2505,7.865 L2.01133333,7.865 Z M-0.000333333333,9.03583333 L10.2621667,9.03583333 L5.13133333,0 L-0.000333333333,9.03583333 Z",
  id: "Fill-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.783,18.8289167 L3.16216667,18.8289167 L1.35133333,15.6930833 L3.16216667,12.5580833 L6.783,12.5580833 L8.593,15.6930833 L6.783,18.8289167 Z M2.48633333,11.38725 L-0.000333333333,15.6930833 L2.48633333,19.99975 L7.45883333,19.99975 L9.94466667,15.6930833 L7.45883333,11.38725 L2.48633333,11.38725 Z",
  id: "Fill-8"
})))));

function SvgResourceWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceWhite);
export default __webpack_public_path__ + "static/media/ResourceWhite.35c9de03.svg";
export { ForwardRef as ReactComponent };